import React, { useState, useEffect, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Puff } from "react-loading-icons";
import NavBar from "../../../../components/NavBar";
import { Grid } from "../../../Layout/Grid/GridView";
import Request from "../../../../api/Requests";
import "./WalletBuyCredits.css"; // Reuse existing styles

const WalletScreen = () => {
    const gridRef = useRef();
    const [isLoading, setIsLoading] = useState(false);
    let params = useParams();
    const navigate = useNavigate();
    const [state, setState] = useState({
        wallet: {
            total_balance: 0,
            transactions: [],
        },
    });

    useEffect(() => {
        getWalletInfo();
    }, []);

    const getWalletInfo = async () => {
        setIsLoading(true);
        let response = await Request('venues/get-wallet-info', 'GET', { id: params.id }, true);
        if (response && response.status) {
            setState({ wallet: response.data });
        }
        setIsLoading(false);
    };


    const handlerBuyCredits = () => {
        navigate(`/my/nightspots/${params.id}/wallet/buy-credits`);
    };

    const InsideLoading = () => {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    flexDirection: "column",
                    minHeight: "400px"
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        maxWidth: "100%",
                    }}
                >
                    <Puff stroke="#11cb5f" height="5em" width="5em" />
                </div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        maxWidth: "100%",
                        marginTop: "1rem",
                        color: "#fff"
                    }}
                >
                    A carregar carteira...
                </div>
            </div>
        );
    };

    const HeaderCards = () => {
        return (
            <div className="row g-4 mb-5">
                <div className="col-md-6">
                    <div className="wallet-card wallet-card-balance">
                        <div className="position-relative z-1">
                            <div className="wallet-card-value">
                                {state.wallet.total_balance}
                            </div>
                            <div className="wallet-card-label">Créditos Disponíveis</div>
                        </div>
                        <i className="fa-solid fa-coins wallet-card-icon"></i>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="wallet-card wallet-card-action" onClick={handlerBuyCredits}>
                        <div className="position-relative z-1">
                            <div className="wallet-card-value">
                                <i className="fa-solid fa-plus-circle me-3"></i>
                            </div>
                            <div className="wallet-card-label">Carregar Conta</div>
                        </div>
                        <i className="fa-solid fa-wallet wallet-card-icon"></i>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div>
            <NavBar>
                <div className="wallet-buy-credits-container">
                    {isLoading ? (
                        <InsideLoading />
                    ) : (
                        <>
                            <div className="row mb-4">
                                <div className="col-12">
                                    <nav aria-label="breadcrumb">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item">
                                                <Link to="/my/dashboard" className="text-muted text-decoration-none">
                                                    <i className="fa-solid fa-home"></i>
                                                </Link>
                                            </li>
                                            <li className="breadcrumb-item">
                                                <Link to="/my/nightspots/" className="text-muted text-decoration-none">Nightspots</Link>
                                            </li>
                                            <li className="breadcrumb-item active text-white" aria-current="page">
                                                Wallet
                                            </li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>

                            <div className="page-header">
                                <h2 className="page-title">A Minha Carteira</h2>
                                <p className="page-subtitle">Gerencie os seus créditos e visualize o histórico de transações.</p>
                            </div>

                            <HeaderCards />

                            <div className="glass-panel p-0 overflow-hidden">
                                <div className="p-4 border-bottom border-white border-opacity-10">
                                    <h5 className="text-white m-0">Histórico de Transações</h5>
                                </div>
                                <div className="p-3">
                                    <Grid
                                        ref={gridRef}
                                        rows={state.wallet.transactions}
                                        height="600px"
                                        pagination={true}
                                        cols={[
                                            { headerName: "Data", field: "datetime" },
                                            {
                                                headerName: "Tipo", field: "type", cellRenderer: (params) => {
                                                    return (
                                                        <div className="d-flex align-items-center gap-2">
                                                            {params.data.type == "CREDIT" ? (
                                                                <>
                                                                    <div className="rounded-circle bg-success bg-opacity-25 p-1 d-flex align-items-center justify-content-center" style={{ width: '24px', height: '24px' }}>
                                                                        <i className="fa-solid fa-arrow-down text-success" style={{ fontSize: '0.8rem' }}></i>
                                                                    </div>
                                                                    <span className="text-success fw-bold">Crédito</span>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div className="rounded-circle bg-danger bg-opacity-25 p-1 d-flex align-items-center justify-content-center" style={{ width: '24px', height: '24px' }}>
                                                                        <i className="fa-solid fa-arrow-up text-danger" style={{ fontSize: '0.8rem' }}></i>
                                                                    </div>
                                                                    <span className="text-danger fw-bold">Débito</span>
                                                                </>
                                                            )}
                                                        </div>
                                                    );
                                                },
                                            },
                                            {
                                                headerName: "Créditos",
                                                field: "value",
                                                cellRenderer: (params) => {
                                                    return (
                                                        <span className={params.data.type == "CREDIT" ? "text-success fw-bold" : "text-white"}>
                                                            {params.data.type == "CREDIT" ? "+" : "-"}{params.value}
                                                        </span>
                                                    )
                                                }
                                            },
                                            { headerName: "Descrição", field: "description" },
                                        ]}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </NavBar>
        </div>
    );
};

export default WalletScreen;